import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "container" }
const _hoisted_2 = { id: "main" }
const _hoisted_3 = { class: "scrollwrapper" }
const _hoisted_4 = { id: "titlebar" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { id: "brand" }, [
  /*#__PURE__*/_createElementVNode("i", null, "easy"),
  /*#__PURE__*/_createTextVNode("NWK")
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("option", { value: "de" }, "Deutsch", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("option", { value: "en" }, "English", -1)
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = { id: "egobar" }
const _hoisted_10 = { id: "forms" }
const _hoisted_11 = { id: "chart" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SideMenu = _resolveComponent("SideMenu")!
  const _component_UndoRedo = _resolveComponent("UndoRedo")!
  const _component_EgoHeader = _resolveComponent("EgoHeader")!
  const _component_EgoEditForm = _resolveComponent("EgoEditForm")!
  const _component_AlteriPanel = _resolveComponent("AlteriPanel")!
  const _component_ViewOptionsPanel = _resolveComponent("ViewOptionsPanel")!
  const _component_ComparisonOptionsPanel = _resolveComponent("ComparisonOptionsPanel")!
  const _component_StatisticsPanel = _resolveComponent("StatisticsPanel")!
  const _component_NetworkMap = _resolveComponent("NetworkMap")!
  const _component_ErrorBoundary = _resolveComponent("ErrorBoundary")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ErrorBoundary, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_SideMenu, {
                onNewNwk: _cache[0] || (_cache[0] = ($event: any) => (_ctx.egoEditMode = true)),
                onOpenNwk: _ctx.editEgoFinished
              }, null, 8, ["onOpenNwk"]),
              _hoisted_5,
              _createVNode(_component_UndoRedo),
              _withDirectives(_createElementVNode("select", {
                id: "langselect",
                name: "lang",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.lang) = $event)),
                onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onLangChange($event)))
              }, _hoisted_8, 544), [
                [_vModelSelect, _ctx.lang]
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              (!_ctx.egoEditMode)
                ? (_openBlock(), _createBlock(_component_EgoHeader, {
                    onEdit: _cache[3] || (_cache[3] = ($event: any) => (_ctx.egoEditMode = true)),
                    key: _ctx.langKey
                  }))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_10, [
              (_ctx.egoEditMode)
                ? (_openBlock(), _createBlock(_component_EgoEditForm, {
                    onEditFinished: _ctx.editEgoFinished,
                    key: _ctx.langKey
                  }, null, 8, ["onEditFinished"]))
                : _createCommentVNode("", true),
              (!_ctx.egoEditMode)
                ? (_openBlock(), _createBlock(_component_AlteriPanel, {
                    mapclicked: _ctx.mapclicked,
                    key: _ctx.langKey
                  }, null, 8, ["mapclicked"]))
                : _createCommentVNode("", true),
              (_openBlock(), _createBlock(_component_ViewOptionsPanel, { key: _ctx.langKey })),
              (_openBlock(), _createBlock(_component_ComparisonOptionsPanel, { key: _ctx.langKey })),
              (_openBlock(), _createBlock(_component_StatisticsPanel, { key: _ctx.langKey }))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          (_openBlock(), _createBlock(_component_NetworkMap, {
            onMapClick: _ctx.mapclick,
            key: _ctx.langKey
          }, null, 8, ["onMapClick"]))
        ])
      ]),
      _: 1
    })
  ]))
}